import { Grid, Card, CardHeader, CardContent, Stack, Typography, Chip, Divider } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { platformApi } from '../../api/platform.api';

const inr = (n = 0) => `₹${Number(n).toLocaleString('en-IN')}`;

export function PlansPage() {
  const plans = useQuery({ queryKey: ['platform', 'plans'], queryFn: () => platformApi.plans() });

  return (
    <>
      <PageHeader title="Subscription Plans" subtitle="The plan catalogue — pricing, limits and bundled modules." />
      <Grid container spacing={2}>
        {(plans.data ?? []).map((p) => (
          <Grid item xs={12} sm={6} md={3} key={p.id}>
            <Card sx={{ height: '100%' }}>
              <CardHeader title={p.name} subheader={p.code} titleTypographyProps={{ variant: 'h6' }} />
              <CardContent>
                <Stack spacing={1}>
                  <Typography variant="h5">{inr(p.monthlyPrice)}<Typography component="span" variant="body2" color="text.secondary">/mo</Typography></Typography>
                  <Typography variant="body2" color="text.secondary">{inr(p.yearlyPrice)}/yr</Typography>
                  <Divider />
                  <Typography variant="body2">Users: <b>{p.userLimit}</b></Typography>
                  <Typography variant="body2">Storage: <b>{(p.storageLimitMb / 1024).toFixed(0)} GB</b></Typography>
                  <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap mt={1}>
                    {p.modules.map((m) => <Chip key={m} size="small" label={m.replace(/_/g, ' ')} variant="outlined" />)}
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
